// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__33bgs","col":"styles_col__2WzpG"};